import { ButtonLink, ButtonLinkAsSimpleText } from '~/prix/react/components/button'
import categories from '../categories'
import styled from 'styled-components'
import { useMemo, useState } from 'react'
import { CategoryButtons, CategoryButtonsDropdown } from './viewSelectModalVariable.categoryButtons'
import { Variable } from '../variable/variables.typing'

const Wrapper = styled.div`
  overflow-y: auto;
  scrollbar-width: none;
  scrollbar-gutter: stable;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    width: 100%;
  }

  h4 {
    display: none;
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
      display: flex;
      font-weight: bold;
      color: #363636;
      font-size: 1rem;
      user-select: none;
      margin: 1.5rem 0 0 1rem;
    }
  }
  .buttons-filter {
    display: none;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
      position: sticky;
      bottom: 0;
      width: 100%;
      display: flex;
      justify-content: end;
    }
  }

  .menu {
    display: flex;
    flex-direction: column;
    border-right: 1px solid ${({ theme }) => theme.colors.lightGrey};
    padding: ${({ theme }) => theme.padding(1)};
    min-height: 100%;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
      width: 100%;
      height: fit-content;
      border-right: none;
      box-shadow: none;
      overflow-y: auto;
    }

    h5 {
      font-weight: 500;
      font-size: 0.8rem;
      text-transform: uppercase;
      margin: 1rem 0;
      color: ${({ theme }) => theme.colors.darkGrey};
      user-select: none;
      letter-spacing: 1px;
    }

    > h5:first-of-type {
      margin-top: 0;
    }

    button {
      border: none;
      outline: none;
      background-color: transparent;
      cursor: pointer;
      font-size: 0.9rem;
      padding: 0.5rem;
      text-align: left;
      color: ${({ theme }) => theme.colors.darkGrey};
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    button:not(.button-active-category):hover {
      background-color: ${({ theme }) => theme.colors.lightGrey};
      color: ${({ theme }) => theme.colors.darkText};
    }

    .button-active-category {
      background-color: ${({ theme }) => theme.colors.primary};
      color: white;
    }

    .category-item-wrapper {
      display: flex;
      flex-direction: column;
    }

    .nested-toggle {
      display: inline-flex;
      align-items: center;
      margin-left: ${({ theme }) => theme.padding(0.3)};
    }

    .nested-category-list {
      display: flex;
      flex-direction: column;
      margin-left: ${({ theme }) => theme.padding(0.6)};
      margin-top: ${({ theme }) => theme.padding(0.2)};
    }

    .nested-category-button {
      font-size: 0.82rem;
      padding-left: ${({ theme }) => theme.padding(1)};
    }
  }
`

const ButtonBack = styled(ButtonLinkAsSimpleText)`
  background-color: #f8f8f8;
  margin-right: 0.5rem;
`

interface CategoryInfo {
  key: string
  title: string
  sectorKey: string
  parentKey?: string
  childrenKeys?: string[]
  defaultChildKey?: string
}

interface WrapperFiltersProps {
  currentCategory: typeof categories
  handleClick: (info: { key: string; title: string; sectorKey: string }) => void
  categoriesInfo: CategoryInfo[]
  setIsFilterOpen: React.Dispatch<React.SetStateAction<boolean>>
  isMobile: boolean
  isModalOpen: boolean
  variables?: Variable[]
}
const WrapperFilters = ({
  categoriesInfo,
  currentCategory,
  handleClick,
  setIsFilterOpen,
  isMobile,
  isModalOpen,
  variables,
}: WrapperFiltersProps) => {
  const [selectedCategory, setSelectedCategory] = useState<typeof categories>(currentCategory)
  const monitorPortfolioCategories = categoriesInfo.filter(
    category => category.sectorKey === 'monitorPortfolio' && !category.parentKey,
  )

  // Categorias
  const staticCategories: { key: string; name: string; isButton?: boolean }[] = [
    { key: 'general', name: 'Geral', isButton: true },
    { key: 'monitorServiceOverview', name: 'Visão geral do atendimento' },
    { key: 'monitorOnlineCourses', name: 'Cursos online' },
    { key: 'monitorAppSebrae', name: 'App SEBRAE' },
    { key: 'agentAttendanceSebrae', name: 'App SEBRAE Atendimentos' },
    // { key: 'monitorPnbox', name: 'PNBOX' },
    { key: 'monitorEmissorNfe', name: 'Emissor NF-e' },
    { key: 'monitorConecta', name: 'Conecta' },
    // Categorias do portfólio
    ...monitorPortfolioCategories.map(portfolio => {
      return {
        key: portfolio.key,
        name: portfolio.title,
      }
    }),
    { key: 'monitorPortfolioOutOfNetwork', name: 'Fora dos portfólios da rede' },
    { key: 'legalEntitiesDropdown', name: 'Empresas' },
    // { key: 'attendanceAppSebrae', name: 'Atendimentos App SEBRAE' },
    // { key: 'legalEntityAppSebraeAttendance', name: 'Empresas distintas atendidas pelo App SEBRAE' },
    // { key: 'legalEntityEadAttendance', name: 'Empresas distintas atendidas pelo EAD' },
    // { key: 'eadEnrollment', name: 'Matrículas no EAD' },
    // { key: 'monitor', name: 'Monitor' },
  ]

  const highlightedCategoryKeys = useMemo(() => {
    //TODO DESTAQUE DE USUÁRIO Remover esse colchete reativa o stars nas categorias do menu.
    return []
    const highlightedVariables = variables?.filter(item => item.userHighlightedVariable)
    if (!highlightedVariables || highlightedVariables?.length === 0) {
      return []
    }
    const highlightedItems: string[] = []

    highlightedVariables?.forEach(variable => {
      variable.categoryKeys?.forEach(key => {
        highlightedItems.push(key)

        // Buscando nas categorias do menu os items para acentuar.
        const categoryEntry = categories[key]
        if (categoryEntry?.sectorKey) {
          highlightedItems.push(categoryEntry.sectorKey)
        }
      })
    })

    const deduplicatedHighlightItems = [...new Set(highlightedItems)]
    return deduplicatedHighlightItems
  }, [variables])

  const handleSelectCategory = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    info: { key: string; title: string; sectorKey: string },
  ) => {
    event.preventDefault()
    event.stopPropagation()
    const newSelectedCategory = {
      [info.key]: {
        title: info.title,
        sectorKey: info.sectorKey,
      },
    }
    setSelectedCategory(newSelectedCategory)
    confirmCategory(event, newSelectedCategory)
  }

  const confirmCategory = (
    event: React.MouseEvent<Element, MouseEvent>,
    selectedCategory: typeof categories,
  ) => {
    event.preventDefault()
    handleClick({
      key: Object.keys(selectedCategory)[0],
      title: selectedCategory[Object.keys(selectedCategory)[0]].title,
      sectorKey: selectedCategory[Object.keys(selectedCategory)[0]].sectorKey,
    })
    setIsFilterOpen(false)
  }

  return (
    <Wrapper>
      <div className='menu'>
        {staticCategories.map(category => {
          const Component = category.isButton ? CategoryButtons : CategoryButtonsDropdown
          return (
            <Component
              key={category.key}
              categoryKey={category.key}
              categoryName={category.name}
              selectedCategory={selectedCategory}
              categoriesInfo={categoriesInfo}
              isMobile={isMobile}
              handleSelectCategory={handleSelectCategory}
              isModalOpen={isModalOpen}
              highlightedCategoryKeys={highlightedCategoryKeys}
            />
          )
        })}
      </div>

      <div className='buttons-filter'>
        <ButtonBack onClick={() => setIsFilterOpen(false)}>Voltar</ButtonBack>
        {/* <ButtonLink
          style={{ marginRight: '7px' }}
          onClick={event => confirmCategory(event, selectedCategory)}
        >
          Filtrar
        </ButtonLink> */}
      </div>
    </Wrapper>
  )
}

export default WrapperFilters
